import {EnvironmentAdmin} from 'compob2b-libs';

/**
 * Конфигурация прод сервера, он же "бой", боевой
 */
export class EnvironmentAdminProd extends EnvironmentAdmin {
  production = true;
  serviceWorkers = true;
  enableWorkflowButton = true;
  serverPicturesPath = 'https://pim.dtm.ru/pictures';
  serverDocumentsPath = 'https://pim.dtm.ru/documents';
  serverApi = 'https://pim.dtm.ru/api/v1';
  serverUrl = 'https://pim.dtm.ru';
  // Корень, а не `/cabinet/dashboard` (SEO-8) — разбор в базовом `Environment.ts`.
  impersonatePortalPath = 'https://pim.dtm.ru/';
  accessRolesCatalog = true;
  showDiscountPanel = true;
  featureGroupPermissions = true;
  damNewPermissions = false;
  damChangeLog = true;
  // Включить меню и функционал витрины в админке
  publicShowcase = true;
  // URL витрины
  publicShowcaseUrl = 'https://show.dtm.ru';
  aiTranslation = true;
  completenessEnabled = true;
  templateDefaultsEnabled = true;
  imageValidator = true;
  xmlImport = true;
  contentLocales = ['ru', 'en', 'kk'];
  commonFeatureGroup = true;
}

export const environment = new EnvironmentAdminProd();
